import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomSnackbarComponent } from './custom-snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class CustomSnackbarService {
  snackBar = inject(MatSnackBar);

  requestSnackbar() {
    this.snackBar.dismiss();
    this.snackBar.openFromComponent(CustomSnackbarComponent, {
      data: { icon: 'send', message: 'Please wait ...', iconColor: '#fff000' },
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    });
  }

  successSnackbar(message: string) {
    this.snackBar.dismiss();
    this.snackBar.openFromComponent(CustomSnackbarComponent, {
      data: { icon: 'check', message: message, iconColor: '#09ff00ff' },
      duration: 7000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    });
  }

  errorSnackbar(message?: string) {
    this.snackBar.dismiss();
    this.snackBar.openFromComponent(CustomSnackbarComponent, {
      data: { icon: 'error', message: message ?? 'An error occurred', iconColor: '#ff0000' },
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['snackbar-error'],
    });
  }

  dismiss() {
    this.snackBar.dismiss();
  }
}
